import { c as _c } from "react/compiler-runtime";
import { Trans, useTranslation } from 'react-i18next';
import React from 'react';
import Floating from '@/sections/Floating';
import { Link } from '@/components/links';
import { LINKS } from '@/constants/links';
export function Prevention() {
  const $ = _c(44);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["shopWisely"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Link analyticsParam="shopWiselyDeferredPayment" testId="shopWiselyDeferredPayment" to={LINKS().deferredPayment} />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  let t3;
  if ($[2] !== t) {
    t2 = <Trans t={t} i18nKey="prevention.items.1.text">{t1}</Trans>;
    t3 = t("prevention.items.1.title");
    $[2] = t;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t) {
    t4 = t("prevention.items.1.title");
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = {
      alt: t4,
      src: "/images/sections/shopWisely/boxes/cs/1.jpg"
    };
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t2 || $[10] !== t3 || $[11] !== t5) {
    t6 = {
      anchorKey: "prevention.items.1.title",
      variant: "small",
      content: t2,
      title: t3,
      image: t5
    };
    $[9] = t2;
    $[10] = t3;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Link analyticsParam="shopWiselyHowToPay" testId="shopWiselyHowToPay" to={LINKS().howToPay} />;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t) {
    t8 = <Trans t={t} i18nKey="prevention.items.2.text">{t7}</Trans>;
    $[14] = t;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t10;
  let t9;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <br />;
    t10 = <br />;
    $[16] = t10;
    $[17] = t9;
  } else {
    t10 = $[16];
    t9 = $[17];
  }
  let t11;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = LINKS().faqQuestion("co-delat-kdyz-nemohu-splacet", "co-mam-delat-kdyz-nestihnu-zaplatit-vcas");
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t) {
    t12 = t("prevention.items.2.link");
    $[19] = t;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t12) {
    t13 = <Link analyticsParam="shopWiselyHowToPay" testId="shopWiselyHowToPay" to={t11}>{t12}</Link>;
    $[21] = t12;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== t13 || $[24] !== t8) {
    t14 = <>{t8}{t9}{t10}{t13}</>;
    $[23] = t13;
    $[24] = t8;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] !== t) {
    t15 = t("prevention.items.2.title");
    $[26] = t;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  let t16;
  if ($[28] !== t) {
    t16 = t("prevention.items.2.title");
    $[28] = t;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  let t17;
  if ($[30] !== t16) {
    t17 = {
      alt: t16,
      src: "/images/sections/shopWisely/boxes/cs/2.jpg"
    };
    $[30] = t16;
    $[31] = t17;
  } else {
    t17 = $[31];
  }
  let t18;
  if ($[32] !== t14 || $[33] !== t15 || $[34] !== t17) {
    t18 = {
      anchorKey: "prevention.items.2.title",
      variant: "small",
      content: t14,
      title: t15,
      image: t17,
      imagePosition: "right"
    };
    $[32] = t14;
    $[33] = t15;
    $[34] = t17;
    $[35] = t18;
  } else {
    t18 = $[35];
  }
  let t19;
  if ($[36] !== t18 || $[37] !== t6) {
    t19 = [t6, t18];
    $[36] = t18;
    $[37] = t6;
    $[38] = t19;
  } else {
    t19 = $[38];
  }
  let t20;
  if ($[39] !== t) {
    t20 = t("prevention.title");
    $[39] = t;
    $[40] = t20;
  } else {
    t20 = $[40];
  }
  let t21;
  if ($[41] !== t19 || $[42] !== t20) {
    t21 = <Floating boxes={t19} title={t20} />;
    $[41] = t19;
    $[42] = t20;
    $[43] = t21;
  } else {
    t21 = $[43];
  }
  return t21;
}